import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
const Footer = () => {
  const [showCookieConsent, setShowCookieConsent] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookieConsent(true);
    }
  }, []);

  const handleCookieConsent = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowCookieConsent(false);
  };

  return (
    <>
      {/* Cookie Consent Banner */}
      {showCookieConsent && (
        <Paper
          elevation={8}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            padding: '16px',
            backgroundColor: (theme) => theme.palette.background.paper,
            borderTop: '2px solid',
            borderColor: (theme) => theme.palette.primary.main,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="body2" sx={{ flex: 1, minWidth: '200px' }}>
              We use cookies to enhance your experience on Snapperish. By continuing to use our site, you agree to our use of cookies.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCookieConsent}
              sx={{ minWidth: 'auto' }}
            >
              OK
            </Button>
          </Box>
        </Paper>
      )}

      {/* Main Footer */}
      <Box
        component="footer"
        sx={{
          backgroundColor: (theme) => theme.palette.background.default,
          borderTop: '1px solid',
          borderColor: (theme) => theme.palette.divider,
          padding: '40px 20px 20px',
          marginTop: 'auto',
        }}
      >
        <Grid container spacing={4} sx={{ maxWidth: '1200px', margin: '0 auto', justifyContent: 'space-between' }}>
          {/* First Column - Site Info */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
              <img
                src="/mascot.png"
                alt="Snapperish Mascot"
                style={{ height: '60px', marginBottom: '16px' }}
              />
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Snapperish
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                The premier platform for club photo<br />contests. Create, manage, and participate<br />in exciting photography competitions with ease.
              </Typography>
            </Box>
          </Grid>

          {/* Second Column - Quick Links */}
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Quick Links
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Link to="/about" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                    About Us
                  </Typography>
                </Link>
                <Link to="/contests" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                    Contests & Galleries
                  </Typography>
                </Link>
                <Link to="/pricing" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                    Pricing
                  </Typography>
                </Link>
                <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                    Contact Us
                  </Typography>
                </Link>
                <Link to="/faq" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                    FAQ
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Grid>

          {/* Third Column - Legal Links */}
          <Grid item xs={12} md={4}>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Legal
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Link to="/acceptableuse" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                      Acceptable Use Policy
                    </Typography>
                  </Link>
                  <Link to="/privacy" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                      Privacy Policy
                    </Typography>
                  </Link>
                  <Link to="/terms" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ '&:hover': { color: 'primary.main' } }}>
                      Terms of Use
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Grid>
        </Grid>

        {/* Copyright */}
        <Box sx={{
          position: 'relative',
          textAlign: 'center',
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid',
          borderColor: (theme) => theme.palette.divider
        }}>
          <Typography variant="body2" color="text.secondary">
            © 2025-2026 Five Pack Creative, Inc. All rights reserved.
          </Typography>
          {process.env.REACT_APP_REVISION && (
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
                fontFamily: 'monospace',
                fontSize: '0.65rem',
                lineHeight: 1,
              }}
            >
              {process.env.REACT_APP_REVISION}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Footer;